// Growth / Revenue / Audience. Every panel stays mounted and only the inactive ones are hidden, so no
// card unmounts or refetches and every honesty caption keeps rendering whichever tab is showing.
import React from 'react';
import { useSearchParams } from 'react-router-dom';

export const DASH_TABS = [
  { key: 'growth', label: 'Growth' },
  { key: 'revenue', label: 'Revenue' },
  { key: 'audience', label: 'Audience' },
];
const KEYS = DASH_TABS.map((t) => t.key);

// The choice lives in the URL (?tab=) so a link or a refresh lands on the same tab.
export function useDashTab() {
  const [params, setParams] = useSearchParams();
  const raw = params.get('tab');
  const tab = KEYS.includes(raw) ? raw : 'growth';
  const setTab = (key) => setParams({ tab: key }, { replace: true });
  return [tab, setTab];
}

export function DashTabs({ value, onChange }) {
  return (
    <div className="adm-tabs" role="tablist" aria-label="Dashboard sections">
      {DASH_TABS.map((t) => (
        <button key={t.key} type="button" role="tab" id={`admin_tab_${t.key}`}
          aria-selected={value === t.key} aria-controls={`admin_panel_${t.key}`}
          className={`adm-tab ${value === t.key ? 'adm-tab--active' : ''}`}
          onClick={() => onChange(t.key)}>{t.label}</button>
      ))}
    </div>
  );
}

export function TabPanel({ name, value, children }) {
  return (
    <div role="tabpanel" id={`admin_panel_${name}`} aria-labelledby={`admin_tab_${name}`}
      data-testid={`admin_panel_${name}`} hidden={value !== name}>
      {children}
    </div>
  );
}
